<!-- 二级分类 卡片式的列表-->
<!-- 一二级表的通用接口：0资产类型，1耗材类型，2故障问题，3保养项目-->
<template>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{this.parentRoute.menuName+'-'+this.route.menuName}}</span>
    </div>

    <Content :isShowNo="isShowNo" :categoryName="categoryName" :type="type"></Content>
  </div>
</template>

<script>
import Content from './content.vue'
import GetDataMixin from '@/mixin/getData-mixin'

export default {
  name: 'assetsCategory',
  components: {
    Content
  },
  mixins: [GetDataMixin],
  data () {
    return {

    }
  },
  props: {
    categoryName: {
      type: String,
      default () {
        return "类型"
      }
    },
    type: {
      type: Number,
      default () {
        return 0
      }
    },
    isShowNo: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
};
</script>
